export interface Comic {
  id: string;
  title: string;
  altTitle: string;
  author: string;
  artist: string;
  category: string;
  tags: string[];
  coverImage: string;
  rating: number;
  rank: number;
  status: string;
  description: string;
  summary: string;
  views: number;
  chapters: number;
  favorites: number;
  updatedAt: string;
  publishedAt: string;
  fullContent: string;
  highlights: string[];
  faq: { question: string; answer: string }[];
}

export const categories = [
  { slug: 'korean', name: '韩漫', icon: 'ri-global-line', description: '韩国漫画精选推荐，热门韩漫一网打尽' },
  { slug: 'japanese', name: '日漫', icon: 'ri-sun-line', description: '日本漫画经典推荐，日漫迷的必看清单' },
  { slug: 'chinese', name: '国漫', icon: 'ri-ancient-gate-line', description: '国产漫画崛起之作，优质国漫推荐' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜恋爱漫画，心动故事合集' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '奇幻世界冒险，想象力无极限' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line', description: '热血战斗漫画，燃爆你的激情' },
];

export const tagList = ['恋爱', '奇幻', '热血', '搞笑', '悬疑', '都市', '校园', '古风', '冒险', '科幻', '治愈', '惊悚'];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '女神降临',
    altTitle: 'True Beauty',
    author: 'Yaongyi',
    artist: 'Yaongyi',
    category: 'korean',
    tags: ['恋爱', '校园', '搞笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20woman%20with%20perfect%20makeup%20looking%20into%20a%20mirror%2C%20soft%20pastel%20background%20with%20cosmetics%20and%20flowers%2C%20romantic%20manga%20cover%20art%20style%2C%20clean%20composition%2C%20warm%20lighting&width=800&height=1120&seq=comic-cover-001&orientation=portrait',
    rating: 9.7,
    rank: 1,
    status: '已完结',
    description: '因为外貌在学校受到霸凌的女主角通过化妆成为校园女神，展开了一段关于自信、爱情和成长的青春故事。',
    summary: '因为长相丑陋而备受欺凌的女高中生任朱静，在转学后通过精湛的化妆技巧华丽变身，成为新学校的"女神"。然而她必须在素颜和带妆的两个身份之间维持平衡，同时面对两位截然不同的男主角——神秘冷酷的李修豪和阳光开朗的韩书俊。这是一部关于外貌焦虑、自我认同和真挚爱情的青春漫画。',
    views: 28500000,
    chapters: 226,
    favorites: 1560000,
    updatedAt: '2025-12-15',
    publishedAt: '2018-04-02',
    fullContent: `<h2>剧情简介</h2><p>《女神降临》是韩国漫画家Yaongyi创作的校园爱情漫画，自2018年开始连载以来，迅速风靡全球。故事围绕着女主角任朱静展开，她因为外貌在学校受到严重的霸凌和歧视。</p><p>在经历了一次痛苦的转学后，朱静通过观看美妆视频自学化妆技巧，在新学校以精致妆容示人，瞬间成为了校园里的焦点人物，被同学们称为"女神"。</p><p>然而，维持这种双重生活并不容易。她必须时刻警惕不让任何人看到自己的素颜，同时还要应对校园生活中的各种挑战。更复杂的是，学校里出现了两个截然不同的男生——性格高冷却内心细腻的李修豪，以及外表阳光内心敏感细腻的韩书俊。</p><p>这部漫画不仅仅是一个简单的恋爱故事，它深入探讨了当代社会中的外貌焦虑、自我认同、家庭关系以及年轻人面临的成长压力。通过朱静的成长历程，作品传递了"真正的美丽来自内心"的温暖信息。</p><h2>角色介绍</h2><p><strong>任朱静</strong> - 女主角，通过化妆技巧改变外貌的普通女孩。善良、坚强但在外貌上极度不自信。</p><p><strong>李修豪</strong> - 神秘的校园风云人物，外表冷酷但内心温柔。与朱静有着意想不到的缘分。</p><p><strong>韩书俊</strong> - 阳光开朗的校园王子，对朱静一见钟情，用直率的方式表达自己的感情。</p><h2>作品特色</h2><p>《女神降临》以其精美的画风和贴近现实的情感描写著称。Yaongyi对时尚和美妆的描绘更是作品的亮点之一，女主角的多样造型引发了大量读者模仿。漫画中对校园霸凌、社交焦虑等现实问题的关注也让作品具有了更深的社会意义。</p>`,
    highlights: ['韩国Webtoon平台年度最佳漫画', '全球累计阅读量超过2.8亿次', '改编电视剧收视率破纪录', '美妆教程与漫画完美融合'],
    faq: [
      { question: '《女神降临》完结了吗？', answer: '是的，《女神降临》已于2023年正式完结，共226话，包括正篇和番外篇。' },
      { question: '《女神降临》有改编作品吗？', answer: '有！《女神降临》已被改编成韩国电视剧，由文佳煐、车银优、黄寅烨主演，2020年在tvN播出。' },
      { question: '《女神降临》适合什么年龄段的读者？', answer: '《女神降临》适合12岁以上的青少年及成人读者，内容健康向上，主题积极。' },
    ],
  },
  {
    id: 'comic-002',
    title: '鬼灭之刃',
    altTitle: 'Demon Slayer: Kimetsu no Yaiba',
    author: '吾峠呼世晴',
    artist: '吾峠呼世晴',
    category: 'japanese',
    tags: ['热血', '奇幻', '冒险'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20cover%20illustration%20featuring%20a%20young%20boy%20with%20a%20sword%20in%20traditional%20kimono%2C%20dramatic%20action%20pose%2C%20water%20breathing%20effects%20flowing%20around%20him%2C%20night%20sky%20with%20moon%2C%20dark%20blue%20and%20red%20color%20scheme%2C%20anime%20style%20art%2C%20heroic%20atmosphere&width=800&height=1120&seq=comic-cover-002&orientation=portrait',
    rating: 9.8,
    rank: 2,
    status: '已完结',
    description: '少年灶门炭治郎为拯救变成鬼的妹妹，踏上猎鬼之路的热血冒险故事。',
    summary: '大正时代的日本，少年灶门炭治郎一家惨遭鬼的屠杀，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎加入了鬼杀队，踏上了斩杀恶鬼的旅程。在经历残酷训练和生死考验后，炭治郎逐渐成长为强大的剑士，并与伙伴们一起对抗鬼的始祖——鬼舞辻无惨。',
    views: 32000000,
    chapters: 205,
    favorites: 1890000,
    updatedAt: '2025-11-20',
    publishedAt: '2016-02-15',
    fullContent: `<h2>剧情简介</h2><p>《鬼灭之刃》是日本漫画家吾峠呼世晴创作的热血奇幻漫画，于2016年2月至2020年5月在《周刊少年Jump》上连载。</p><p>故事发生在日本大正时代。卖炭少年灶门炭治郎在回家后，发现全家人被鬼屠杀，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎在鬼杀队水柱富冈义勇的指引下，拜鳞泷左近次为师学习水之呼吸剑术。</p><p>经过严酷的最终选拔，炭治郎正式加入鬼杀队，与善逸、伊之助等伙伴一起执行猎鬼任务。他们逐渐揭开了鬼的始祖——鬼舞辻无惨的阴谋，并踏上了最终决战的征程。</p><h2>作品特色</h2><p>《鬼灭之刃》以其独特的浮世绘风格画风、紧凑的剧情节奏和深刻的情感描写受到广泛赞誉。作品中"呼吸法"的设定极具创意，将日本传统武士精神与现代漫画技巧完美融合。每个角色都有完整的背景故事和成长弧线，让读者能够与角色产生强烈的情感共鸣。</p><p>2019年动画版播出后，作品人气达到了空前的高度，剧场版《无限列车篇》更是打破了日本电影票房记录。</p>`,
    highlights: ['日本漫画销量历史第一名', '剧场版票房突破400亿日元', '获得多项漫画大奖', '动画制作水准顶级'],
    faq: [
      { question: '《鬼灭之刃》漫画完结了吗？', answer: '是的，《鬼灭之刃》漫画已于2020年5月正式完结，共205话。' },
      { question: '动画版和漫画版有什么区别？', answer: '动画版由ufotable制作，画质精美，战斗场景震撼。漫画版则有更多细节和内心独白，两者互为补充。' },
      { question: '推荐观看顺序是什么？', answer: '推荐先看动画第一季，再看剧场版《无限列车篇》，接着看动画第二季《游郭篇》，最后可以补完漫画后续内容。' },
    ],
  },
  {
    id: 'comic-003',
    title: '斗罗大陆',
    altTitle: 'Soul Land',
    author: '唐家三少',
    artist: '穆逢春',
    category: 'chinese',
    tags: ['奇幻', '冒险', '热血'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20featuring%20a%20young%20warrior%20with%20flowing%20blue%20hair%20holding%20a%20glowing%20weapon%2C%20martial%20arts%20fantasy%20style%2C%20mystical%20blue%20and%20gold%20spirit%20energy%20surrounding%20him%2C%20epic%20landscape%20with%20mountains%20in%20background%2C%20clean%20and%20dynamic%20composition&width=800&height=1120&seq=comic-cover-003&orientation=portrait',
    rating: 9.5,
    rank: 3,
    status: '连载中',
    description: '唐门外门弟子唐三穿越到斗罗大陆，觉醒双生武魂，踏上强者之路的传奇故事。',
    summary: '唐门外门弟子唐三因偷学内门绝学被逼跳崖，却意外穿越到斗罗大陆的圣魂村，成为铁匠唐昊的儿子。在这个人人拥有武魂的世界里，唐三觉醒了罕见的双生武魂——蓝银草和昊天锤。他进入诺丁学院开始修炼，结识了伙伴小舞，并一步步踏上了成为封号斗罗的传奇旅程。',
    views: 41000000,
    chapters: 650,
    favorites: 2300000,
    updatedAt: '2026-01-10',
    publishedAt: '2011-03-01',
    fullContent: `<h2>剧情简介</h2><p>《斗罗大陆》是中国网络作家唐家三少创作的奇幻小说，后由穆逢春改编为漫画。这是中国最成功的网络小说IP之一，漫画版更是将宏大的世界观以视觉方式完美呈现。</p><p>故事讲述了唐门弟子唐三穿越到一个名为斗罗大陆的世界，这里每个人都有属于自己的武魂。唐三觉醒了两大武魂——看似废柴的蓝银草和力量恐怖的昊天锤，开始了他的修炼之路。</p><p>从圣魂村到诺丁学院，从史莱克学院到武魂殿，唐三与伙伴们一路成长，不断变强。他不仅要面对强大的敌人，还要揭开自己身世的秘密和母亲的真相。</p><h2>作品特色</h2><p>《斗罗大陆》构建了一个完整而富有想象力的修炼体系，从魂士到封号斗罗的等级设定清晰明了。漫画版在保持原作精髓的基础上，以精美的画风展现了武魂、魂技和激烈战斗的视觉魅力。</p><p>作品中的伙伴情谊、师徒之情和家国情怀深深打动了亿万读者，唐三与小舞的爱情故事更是让人动容。</p>`,
    highlights: ['中国漫画连载时间最长作品之一', '全网点击量突破410亿', '改编动画播放量超500亿', 'IP衍生作品覆盖游戏、影视、周边'],
    faq: [
      { question: '《斗罗大陆》漫画和小说一样吗？', answer: '漫画版忠于原著小说的主线剧情，但在一些细节和节奏上做了调整，更加适合漫画的叙事方式。' },
      { question: '《斗罗大陆》动画版到哪了？', answer: '动画版已播出多季，涵盖了原作的大半内容，目前仍在持续更新中。' },
      { question: '唐三最后的等级是什么？', answer: '唐三最终成就了海神和修罗神双神位，成为斗罗大陆最强大的存在。' },
    ],
  },
  {
    id: 'comic-004',
    title: '我独自升级',
    altTitle: 'Solo Leveling',
    author: 'Chugong',
    artist: 'Jang Sung-rak',
    category: 'korean',
    tags: ['热血', '奇幻', '都市'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20atmospheric%20Korean%20webtoon%20cover%20featuring%20a%20solo%20male%20character%20with%20short%20dark%20hair%20and%20glowing%20purple%20eyes%2C%20wearing%20a%20black%20coat%2C%20standing%20in%20front%20of%20a%20shadow%20army%2C%20dark%20fantasy%20theme%2C%20with%20mysterious%20portal%20gate%20in%20the%20background%2C%20dramatic%20lighting&width=800&height=1120&seq=comic-cover-004&orientation=portrait',
    rating: 9.9,
    rank: 4,
    status: '已完结',
    description: '最弱猎人成肖宇在濒死之际获得「系统」能力，从E级猎人逆袭成为最强存在。',
    summary: '在一个突然出现"门"与"猎人"的世界中，E级猎人成肖宇被称为"人类最弱兵器"。在一次几乎全灭的地下城探险中，他濒死时刻意外获得了神秘的"系统"能力，成为了唯一能够通过升级变强的"玩家"。从最弱到最强，成肖宇的逆袭之路就此展开。',
    views: 38000000,
    chapters: 179,
    favorites: 2100000,
    updatedAt: '2025-10-05',
    publishedAt: '2018-03-04',
    fullContent: `<h2>剧情简介</h2><p>《我独自升级》是韩国作家Chugong创作的网络小说，由Jang Sung-rak（DUBU）改编为漫画。这部作品以其独特的世界观设定和精彩的战斗场面，在全球范围内获得了巨大成功。</p><p>故事设定在一个突然出现了连接异次元的"门"的世界。一部分人类觉醒成为了"猎人"，拥有对抗门内魔物的力量。主角成肖宇是猎人中最弱的存在——E级猎人，被称为"人类最弱兵器"。</p><p>在一次地下城探险中遭遇几乎全灭的绝境后，成肖宇意外获得了神秘的"系统"界面，成为唯一一个可以通过打怪升级、完成任务来提升实力的存在。从此，他踏上了从最弱猎人到最强存在的逆袭之旅。</p><h2>作品特色</h2><p>作品将RPG游戏元素与漫画叙事完美结合，升级系统的设定让读者有极强的代入感。DUBU的画风极具冲击力，战斗场面的表现力达到了韩国漫画的顶级水准。主角从弱者到强者的成长弧线设计精妙，让人欲罢不能。</p>`,
    highlights: ['全球Webtoon平台排名第一', '改编动画确定制作', '独特RPG升级系统设定', '画风精美打斗场面震撼'],
    faq: [
      { question: '《我独自升级》漫画完结了吗？', answer: '漫画版已于2021年正式完结，共179话。番外篇也已发布完毕。' },
      { question: '有动画版吗？', answer: '是的！《我独自升级》动画版已确定由A-1 Pictures制作，备受期待。' },
      { question: '小说和漫画哪个更好看？', answer: '两者各有特点。小说有更多细节和心理描写，漫画版则视觉效果更加震撼，推荐都看。' },
    ],
  },
  {
    id: 'comic-005',
    title: '排球少年！！',
    altTitle: 'Haikyu!!',
    author: '古馆春一',
    artist: '古馆春一',
    category: 'japanese',
    tags: ['热血', '校园', '搞笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20sports%20manga%20cover%20featuring%20an%20energetic%20orange-haired%20boy%20jumping%20high%20to%20spike%20a%20volleyball%2C%20wearing%20black%20and%20orange%20jersey%2C%20dynamic%20sports%20action%20illustration%2C%20bright%20gymnasium%20background%20with%20teammates%2C%20inspiring%20and%20energetic%20atmosphere%2C%20clean%20anime%20art%20style&width=800&height=1120&seq=comic-cover-005&orientation=portrait',
    rating: 9.6,
    rank: 5,
    status: '已完结',
    description: '矮个子少年日向翔阳追逐排球梦想，与天才二传手影山飞雄携手挑战巅峰。',
    summary: '身高只有162cm的日向翔阳，被乌野高中排球部的"小巨人"所激励，决定踏上排球之路。进入乌野高中后，他却遇到了曾经的手下败将——被称为"球场上的王者"的天才二传手影山飞雄。两人从对手成为队友，在磨合中不断成长，带领乌野高中向全国大赛发起冲击。',
    views: 22000000,
    chapters: 402,
    favorites: 1350000,
    updatedAt: '2025-08-30',
    publishedAt: '2012-02-20',
    fullContent: `<h2>剧情简介</h2><p>《排球少年！！》是日本漫画家古馆春一创作的运动题材漫画，于2012年至2020年在《周刊少年Jump》连载。这部作品不仅在日本国内获得了巨大成功，也在全球范围内掀起了排球热潮。</p><p>主人公日向翔阳在初中时被电视上乌野高中排球部的"小巨人"激励，开始打排球。尽管初中时的队友只有临时拼凑的成员，但他凭借惊人的弹跳力和永不放弃的精神给对手留下了深刻印象。</p><p>进入乌野高中后，日向遇到了他初中时的对手——天才二传手影山飞雄。两人从互不服气到成为最佳搭档，带领乌野高中排球部从"没落的强豪"重回巅峰。</p><h2>作品特色</h2><p>《排球少年！！》以其真实细腻的比赛描写和鲜明立体的角色塑造著称。古馆春一将排球运动的速度感和战术深度完美呈现在漫画中，每一场比赛都让人热血沸腾。角色之间的羁绊和成长更是打动了无数读者。</p>`,
    highlights: ['日本漫画史上最佳运动漫画之一', '动画制作精良口碑爆棚', '真实还原排球运动魅力', '角色塑造深入人心'],
    faq: [
      { question: '《排球少年！！》漫画和动画都完结了吗？', answer: '漫画已于2020年完结，共402话。动画版已制作四季，剧场版也已上映。' },
      { question: '这部漫画适合不打排球的人看吗？', answer: '完全适合！作品的核心是青春、努力和团队精神，即使不懂排球规则也能被深深打动。' },
    ],
  },
  {
    id: 'comic-006',
    title: '狐妖小红娘',
    altTitle: 'Fox Spirit Matchmaker',
    author: '小新',
    artist: '小新',
    category: 'chinese',
    tags: ['恋爱', '奇幻', '古风'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20manhua%20cover%20featuring%20a%20beautiful%20fox-spirit%20girl%20with%20long%20pink%20hair%20and%20traditional%20elegant%20hanfu%20dress%2C%20surrounded%20by%20cherry%20blossoms%20and%20magical%20pink%20orbs%2C%20romantic%20and%20mystical%20ancient%20Chinese%20aesthetic%2C%20soft%20dreamy%20atmosphere%2C%20warm%20pastel%20colors&width=800&height=1120&seq=comic-cover-006&orientation=portrait',
    rating: 9.4,
    rank: 6,
    status: '连载中',
    description: '以红娘身份撮合人妖恋情的狐妖涂山苏苏，在完成红线任务中揭开前世今生的羁绊。',
    summary: '在人与妖共存的世界中，狐妖涂山苏苏是一名见习红娘，她的工作是帮助前世有缘的人与妖在今生重逢并续前缘。看似迷糊的小狐妖，实际上承载着一段尘封千年的往事。在与道士白月初相遇后，两人展开了一段跨越前世今生的奇幻旅程。',
    views: 18000000,
    chapters: 520,
    favorites: 980000,
    updatedAt: '2026-01-05',
    publishedAt: '2013-06-01',
    fullContent: `<h2>剧情简介</h2><p>《狐妖小红娘》是中国漫画家小新创作的奇幻爱情漫画。在这个人与妖共存的世界中，狐妖一族的红娘负责帮助前世的恋人在今生重逢。</p><p>涂山苏苏是涂山狐妖一族中最"笨拙"的见习红娘，但她的真实身份却远超表面。当她遇到贪财的道士白月初后，一段跨越千年的前世今生故事徐徐展开。</p><p>作品通过一个个独立的篇章讲述了不同角色的爱情故事，这些故事又彼此交织，最终汇成了一个宏大的史诗。</p><h2>作品特色</h2><p>《狐妖小红娘》将中国传统文化中的狐妖传说与现代漫画叙事相结合，创造了一个独特而迷人的世界观。漫画画风唯美，情感描写细腻，每一个故事篇章都能引发读者的强烈共鸣。</p>`,
    highlights: ['中国原创漫画标杆之作', '动画改编大获成功', '融合中国传统文化元素', '情感描写细腻动人'],
    faq: [
      { question: '《狐妖小红娘》有多少个篇章？', answer: '漫画分为多个篇章，包括《下沙篇》《王权篇》《月红篇》《千颜篇》《南国篇》《竹业篇》《尾生篇》《金晨曦篇》《沐天城篇》《两生花篇》等，每个篇章都是独立又相互关联的故事。' },
    ],
  },
  {
    id: 'comic-007',
    title: '间谍过家家',
    altTitle: 'SPY×FAMILY',
    author: '远藤达哉',
    artist: '远藤达哉',
    category: 'japanese',
    tags: ['搞笑', '悬疑', '治愈'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20comedy%20manga%20cover%20featuring%20three%20characters%20posing%20as%20a%20family%2C%20a%20man%20in%20a%20green%20suit%2C%20a%20woman%20with%20long%20red%20hair%20in%20a%20red%20dress%2C%20and%20a%20cute%20pink-haired%20little%20girl%20holding%20a%20plush%20toy%2C%20chic%20retro%20European%20aesthetic%2C%20warm%20pastel%20background%20with%20peanuts%20motif&width=800&height=1120&seq=comic-cover-007&orientation=portrait',
    rating: 9.7,
    rank: 7,
    status: '连载中',
    description: '间谍、杀手和超能力少女组成虚假家庭，在隐瞒身份中上演爆笑温馨日常。',
    summary: '为了执行维护和平的秘密任务，代号"黄昏"的顶级间谍需要一个虚假的家庭做掩护。他收养了能读心的超能力少女阿尼亚，又"招募"了暗中是职业杀手的约尔作为妻子。三个各怀秘密的人组成了名为"福杰"的家庭，在执行任务的同时，奇妙而温馨的家庭羁绊也在悄然生长。',
    views: 25000000,
    chapters: 98,
    favorites: 1680000,
    updatedAt: '2026-01-15',
    publishedAt: '2019-03-25',
    fullContent: `<h2>剧情简介</h2><p>《间谍过家家》是日本漫画家远藤达哉创作的搞笑间谍漫画，自2019年在《少年Jump+》连载以来，迅速成为现象级作品。</p><p>为了维护东西两国之间的和平，代号"黄昏"的西国顶级间谍接到了一项秘密任务——接近东国政要多诺万·德斯蒙德。为此，他需要在七天内组建一个家庭，通过子女学校的家长会来接触到目标。</p><p>黄昏化名劳埃德·福杰，收养了孤儿院中能读心的超能力少女阿尼亚，又在不知情的情况下与东国的职业杀手约尔（代号"荆棘公主"）假结婚。三人组成了各怀秘密的"福杰家族"。</p><h2>作品特色</h2><p>《间谍过家家》将间谍动作、家庭喜剧和超自然元素完美融合。作品最打动人的地方在于，这个由谎言组成的家庭中，却在不知不觉间产生了最真挚的亲情羁绊。每个角色都有让人捧腹的槽点，也有让人泪目的时刻。</p>`,
    highlights: ['2022年动画化后席卷全球', '漫画累计发行量突破3000万册', '阿尼亚表情包风靡社交媒体', '间谍与家庭题材巧妙融合'],
    faq: [
      { question: '《间谍过家家》动画有几季？', answer: '目前动画已播出两季，外加一部剧场版《间谍过家家 CODE: White》，制作精良广受好评。' },
      { question: '漫画现在还在连载吗？', answer: '是的，漫画仍在连载中，每两周更新一话，故事还在继续展开。' },
    ],
  },
  {
    id: 'comic-008',
    title: '全职高手',
    altTitle: 'The King\'s Avatar',
    author: '蝴蝶蓝',
    artist: 'DLAN',
    category: 'chinese',
    tags: ['热血', '都市', '搞笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20esports%20themed%20manhua%20cover%20featuring%20a%20cool%20male%20character%20with%20silver%20hair%20holding%20a%20gaming%20mouse%2C%20wearing%20a%20casual%20jacket%2C%20with%20a%20glowing%20game%20character%20avatar%20behind%20him%2C%20futuristic%20cyberpunk%20vibe%2C%20clean%20modern%20illustration%20style%2C%20blue%20and%20white%20color%20scheme&width=800&height=1120&seq=comic-cover-008&orientation=portrait',
    rating: 9.3,
    rank: 8,
    status: '连载中',
    description: '荣耀第一人叶修被俱乐部驱逐后，从网吧重新开始，用实力重回巅峰的电竞传奇。',
    summary: '被誉为"荣耀教科书"的顶尖电竞选手叶修，在职业生涯巅峰期被俱乐部驱逐，被迫退役。他来到一家网吧当网管，从零开始创建新角色"君莫笑"，凭借着十年积累的顶尖游戏理解和战术素养，在荣耀新区搅动风云，一步步再次攀向荣耀之巅。',
    views: 16000000,
    chapters: 360,
    favorites: 890000,
    updatedAt: '2025-12-20',
    publishedAt: '2015-10-01',
    fullContent: `<h2>剧情简介</h2><p>《全职高手》是中国作家蝴蝶蓝创作的电子竞技题材小说，漫画版由DLAN改编绘制。故事以虚构的竞技网游《荣耀》为背景，展现了中国电竞圈的方方面面。</p><p>叶修是荣耀职业联赛的传奇人物，带领嘉世战队拿下三连冠，被誉为"荣耀教科书"。然而因为与俱乐部的理念不合，他在巅峰期被俱乐部驱逐并被迫退役。</p><p>失去一切的叶修来到一家名为"兴欣"的网吧当网管，凭借对荣耀的深刻理解和超凡的操作技巧，他创建新角色"君莫笑"，从游戏新区开始重新出发。</p><h2>作品特色</h2><p>《全职高手》最突出的特点是其对电子竞技的真实还原和对游戏战术的精彩描写。作品中每一个战斗细节都经得起推敲，让读者仿佛亲历了一场场精彩的电竞对决。同时，作品中丰满了众多角色的形象，每个角色都有独特的性格和成长弧线。</p>`,
    highlights: ['中国电竞题材漫画代表作', '动画化后播放量超百亿', '真实反映中国电竞生态', '战术描写专业严谨'],
    faq: [
      { question: '《全职高手》动画版好看吗？', answer: '动画版制作精良，战斗场景和特效非常出色。目前已播出三季，第四季也在制作中。' },
      { question: '叶修最后的结局是什么？', answer: '叶修带领新成立的兴欣战队杀入职业联盟，并最终在第十赛季重新夺得了荣耀总冠军。' },
    ],
  },
  {
    id: 'comic-009',
    title: '神之塔',
    altTitle: 'Tower of God',
    author: 'SIU',
    artist: 'SIU',
    category: 'korean',
    tags: ['奇幻', '冒险', '悬疑'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20fantasy%20cover%20featuring%20a%20young%20boy%20with%20brown%20hair%20looking%20up%20at%20a%20massive%20mysterious%20tower%20reaching%20into%20the%20sky%2C%20fantasy%20adventure%20theme%2C%20epic%20scale%2C%20starry%20night%20sky%2C%20mysterious%20atmosphere%2C%20detailed%20illustration%20style&width=800&height=1120&seq=comic-cover-009&orientation=portrait',
    rating: 9.2,
    rank: 9,
    status: '连载中',
    description: '少年夜为了追寻唯一的朋友蕾哈尔，闯入神秘之塔，展开层层试炼的奇幻冒险。',
    summary: '在一个巨大的神秘之塔中，每一层都有不同的世界和考验。少年夜为了追寻他唯一的朋友蕾哈尔，闯入了这座塔。在这座塔中，他遇到了各种各样的伙伴和对手，经历了生死考验，也一步步揭开了塔和自己身世的秘密。',
    views: 20000000,
    chapters: 580,
    favorites: 1200000,
    updatedAt: '2026-01-08',
    publishedAt: '2010-06-30',
    fullContent: `<h2>剧情简介</h2><p>《神之塔》是韩国漫画家SIU创作的长篇奇幻漫画，是韩国Webtoon平台最长寿、最受欢迎的作品之一。</p><p>故事围绕着一座神秘的通天之塔展开。在这座塔中，每一层都相当于一个独立的世界。人们相信，爬到塔顶的人可以实现任何愿望。少年"夜"为了追寻他唯一的朋友蕾哈尔，闯入了这座塔。</p><p>在爬塔的过程中，夜遇到了来自不同背景的伙伴们——昆家的天才昆·阿圭罗·阿尼亚斯、强悍的鳄鱼战士雷克·莱克雷什尔等。他们在每一层的试炼和与强敌的对抗中不断成长。</p><h2>作品特色</h2><p>《神之塔》最引人注目的是其宏大的世界观构建。每一层塔都有着独特的文化、规则和生态，SIU的想象力令人叹为观止。作品中的角色设计独特且丰富，智斗和战斗并重，节奏把控精妙。</p>`,
    highlights: ['韩国Webtoon平台头部IP', '世界观构建堪称史诗级', '动画化获得广泛好评', '连载超过10年品质不减'],
    faq: [
      { question: '《神之塔》还在连载吗？', answer: '是的，《神之塔》仍在连载中，目前已经超过580话，剧情仍在深入展开。' },
      { question: '动画版的内容对应漫画哪里？', answer: '动画第一季覆盖了漫画第一部的故事，即塔的测试层篇。后续内容在漫画中可以继续阅读。' },
    ],
  },
  {
    id: 'comic-010',
    title: '咒术回战',
    altTitle: 'Jujutsu Kaisen',
    author: '芥见下下',
    artist: '芥见下下',
    category: 'japanese',
    tags: ['热血', '奇幻', '悬疑'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20dark%20fantasy%20manga%20cover%20featuring%20a%20spiky%20haired%20boy%20in%20a%20dark%20school%20uniform%20with%20red%20energy%20surrounding%20his%20fist%2C%20intense%20battle-ready%20pose%2C%20dark%20urban%20background%20with%20cursed%20spirits%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20supernatural%20horror%20vibes&width=800&height=1120&seq=comic-cover-010&orientation=portrait',
    rating: 9.5,
    rank: 10,
    status: '连载中',
    description: '高中生虎杖悠仁吞下诅咒手指后，加入咒术高专，与诅咒展开生死搏斗。',
    summary: '拥有超人身体素质的高中生虎杖悠仁，在一次偶然事件中吞下了诅咒之王两面宿傩的手指，成为了宿傩的容器。为了收集散落各地的宿傩手指并保护他人，虎杖加入了东京咒术高专，与伏黑惠、钉崎野蔷薇等伙伴一起接受咒术训练，对抗不断出现的诅咒和咒术师中的叛徒。',
    views: 28000000,
    chapters: 260,
    favorites: 1750000,
    updatedAt: '2026-01-12',
    publishedAt: '2018-03-05',
    fullContent: `<h2>剧情简介</h2><p>《咒术回战》是日本漫画家芥见下下创作的暗黑奇幻热血漫画，于2018年3月开始在《周刊少年Jump》连载。</p><p>故事设定在一个诅咒与咒术并存的世界。人类负面情绪会产生"诅咒"，而能够对抗诅咒的"咒术师"通过使用咒力来驱除诅咒。</p><p>拥有超凡体能的高中生虎杖悠仁，在一次意外中为了保护他人，吞下了诅咒之王两面宿傩的其中一根手指，成为了宿傩的容器。随后，他在最强咒术师五条悟的引荐下加入了东京咒术高专，与伙伴们一起对抗威胁人类的诅咒。</p><h2>作品特色</h2><p>《咒术回战》以其暗黑的世界观、激烈的战斗场面和独特的咒术体系设定受到热捧。芥见下下的画风和分镜极具张力，战斗场景充满创意和视觉冲击力。作品也不回避残酷和牺牲，情感表达真挚有力。</p>`,
    highlights: ['Jump系近年最热作品之一', '动画版由MAPPA制作质量顶级', '世界观设定独特有深度', '角色魅力十足'],
    faq: [
      { question: '《咒术回战》漫画现在进行到哪里了？', answer: '漫画目前正在进行激烈的最终决战篇章，剧情进入了高潮阶段。' },
      { question: '动画第二季覆盖了漫画哪些内容？', answer: '动画第二季涵盖了漫画的"怀玉·玉折"篇和"涩谷事变"篇，是整部作品最重要的转折点。' },
    ],
  },
  {
    id: 'comic-011',
    title: '甜蜜的陷阱',
    altTitle: 'Sweet Trap',
    author: '喵呜',
    artist: '喵呜',
    category: 'chinese',
    tags: ['恋爱', '都市', '搞笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20romance%20manhua%20cover%20featuring%20a%20handsome%20male%20CEO%20and%20a%20cute%20female%20pastry%20chef%2C%20both%20looking%20at%20each%20other%20with%20sparkling%20eyes%2C%20surrounded%20by%20delicious%20desserts%20and%20pastries%2C%20warm%20and%20sweet%20atmosphere%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20romantic%20illustration&width=800&height=1120&seq=comic-cover-011&orientation=portrait',
    rating: 8.9,
    rank: 11,
    status: '已完结',
    description: '甜品师林糖糖与高冷总裁陆瑾年的甜蜜爱情故事，职场与甜点交织的浪漫。',
    summary: '林糖糖是一位热爱烘焙的甜品师，梦想开一家属于自己的甜品店。一次偶然的机会，她进入了一家顶级酒店工作，遇到了以严苛著称的总裁陆瑾年。从误会到理解，从对抗到心动，两人在甜点的世界里展开了一段甜美而温暖的爱情故事。',
    views: 8500000,
    chapters: 98,
    favorites: 620000,
    updatedAt: '2025-09-15',
    publishedAt: '2020-03-10',
    fullContent: `<h2>剧情简介</h2><p>《甜蜜的陷阱》是中国漫画家喵呜创作的都市恋爱漫画。故事围绕甜品师林糖糖和酒店集团总裁陆瑾年之间的爱情展开。</p><p>林糖糖从小就梦想成为一名优秀的甜品师，用美味的甜点给人们带来幸福。当她终于进入心仪已久的顶级酒店甜品部工作后，却遇到了以严苛闻名的总裁陆瑾年。</p><p>一开始两人水火不容，陆瑾年对糖糖的每一个作品都吹毛求疵。但在一次次的交锋中，他们逐渐发现了对方身上的闪光点。而糖糖用心制作的每一道甜品，也在不经意间融化着陆瑾年冰封的心。</p><h2>作品特色</h2><p>作品在传统恋爱漫画的基础上，融入了大量关于甜点制作的知识和细节。每一话中出现的甜品都是真实存在的经典作品，让读者在感受甜蜜爱情的同时也能领略甜点文化的魅力。</p>`,
    highlights: ['画风清新甜美', '甜点专业知识丰富', '职场与爱情双线并进', '轻松解压的阅读体验'],
    faq: [
      { question: '《甜蜜的陷阱》完结了吗？', answer: '是的，正篇已经完结，共98话。作者还推出了几篇甜蜜的番外篇。' },
    ],
  },
  {
    id: 'comic-012',
    title: '异世界舅舅',
    altTitle: 'Uncle from Another World',
    author: '殆ど死んでいる',
    artist: '殆ど死んでいる',
    category: 'japanese',
    tags: ['搞笑', '奇幻', '都市'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Japanese%20comedy%20manga%20cover%20featuring%20a%20middle-aged%20man%20with%20unkempt%20hair%20and%20stubble%20dressed%20in%20casual%20clothes%20holding%20a%20SEGA%20game%20controller%2C%20surrounded%20by%20fantasy%20world%20elements%20like%20magic%20circles%20and%20monsters%2C%20humorous%20contrast%20between%20modern%20Japan%20and%20fantasy%20world%2C%20colorful%20fun%20illustration&width=800&height=1120&seq=comic-cover-012&orientation=portrait',
    rating: 9.1,
    rank: 12,
    status: '连载中',
    description: '昏迷17年的舅舅从异世界归来，用魔法展示异世界冒险经历，笑料百出。',
    summary: '高丘敬文的舅舅在车祸后昏迷了17年，醒来后声称自己穿越到了异世界。没有人相信他，直到他在医院里施展了魔法。舅舅开始向敬文讲述自己在异世界的冒险故事——一个因长相丑陋而被误认为是兽人的日本人，如何在异世界中凭借SEGA游戏的执念闯荡的爆笑故事。',
    views: 12000000,
    chapters: 54,
    favorites: 780000,
    updatedAt: '2025-11-30',
    publishedAt: '2017-12-29',
    fullContent: `<h2>剧情简介</h2><p>《异世界舅舅》是日本漫画家殆ど死んでいる创作的搞笑奇幻漫画。作品以独特的视角重新演绎了异世界穿越题材。</p><p>故事开篇：高丘敬文的舅舅在17年前遭遇车祸后陷入昏迷，如今突然苏醒，并声称自己穿越到了异世界。所有人都认为他在胡说，直到他在医院里施展了真正的魔法。</p><p>舅舅开始通过魔法投影向敬文展示自己在异世界的冒险记忆。然而，因为舅舅长相粗犷，在异世界中被所有人误认为是危险的兽人，闹出了无数笑话。而他最大的执念竟然是——错过了17年的SEGA游戏。</p><h2>作品特色</h2><p>《异世界舅舅》最大的特点是对异世界穿越题材的颠覆性改造。主角没有帅气的外表，也没有开挂的能力，全靠智慧和SEGA梗在异世界求生存。作品的喜剧节奏精准，吐槽和反套路层出不穷。</p>`,
    highlights: ['异世界题材的另类演绎', 'SEGA游戏梗贯穿全篇', '搞笑与温情并存', '动画化后人气飙升'],
    faq: [
      { question: '《异世界舅舅》动画有几季？', answer: '动画目前已播出一季，共13集。第二季已宣布制作。' },
      { question: '舅舅真的去了异世界吗？', answer: '在作品的设定中，舅舅确实穿越到了异世界，他的魔法能力和记忆都是真实的。' },
    ],
  },
];

export const rankings = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

export const getComicsByCategory = (categorySlug: string) => {
  if (['korean', 'japanese', 'chinese'].includes(categorySlug)) {
    return comics.filter((c) => c.category === categorySlug);
  }
  return comics.filter((c) => c.tags.includes(
    categories.find((cat) => cat.slug === categorySlug)?.name || '',
  ));
};

export const getComicById = (id: string) => comics.find((c) => c.id === id) || null;

export const featuredComics = comics.slice(0, 6);